/**
 * Section Constants.
 */

/**
 * A partial list of institution codes. See https://jira.cac.washington.edu/browse/MYPLAN-1583 for a longer list
 * and discussion.
 */
export const InstitutionCodes = {
    MAIN: 0,
    ROTC: 88,
    PCE: 95
};